/**
 * Small shared facts about study-room tabs (memory/systems/study-rooms.md), kept apart from the chat
 * store so the screen can read them without the store's weight.
 */

import { signal } from '@preact/signals';

/** What a Study tab is called until its agent names it after the subject (scripts/rooms/study.py). */
export const NEW_ROOM_TITLE = 'New study';

/**
 * Titles a Study tab can carry before it has a subject: ours, the old working name of a room tab, the
 * server's own name for a profile tab (when the rename did not land), and the title a context clear
 * gives an unpinned tab.
 */
const UNNAMED_ROOM_TITLES = new Set([NEW_ROOM_TITLE, 'New room', '\u{1F6E0} study-room', 'New Chat']);

export function isUnnamedRoom(title: string | null | undefined): boolean {
  return UNNAMED_ROOM_TITLES.has((title ?? '').trim());
}

/** Room tabs whose engine could not be set to Opus when they were opened. The tab says so. */
export const roomEngineUnset = signal<ReadonlySet<number>>(new Set());

export function markRoomEngine(chatId: number, isSet: boolean): void {
  if (roomEngineUnset.value.has(chatId) !== isSet) return;
  const next = new Set(roomEngineUnset.value);
  if (isSet) next.delete(chatId);
  else next.add(chatId);
  roomEngineUnset.value = next;
}
